import React from 'react';
import { Card, Table, Tag, Collapse, Space, Typography, Statistic } from 'antd';
import { 
    CheckCircleOutlined, 
    WarningOutlined,
    EnvironmentOutlined,
    ClockCircleOutlined
} from '@ant-design/icons';

const { Panel } = Collapse;
const { Text } = Typography;

/**
 * 航线实例卡片组件
 * 展示单个航线实例及其包含的航段
 */
const RouteInstanceCard = ({ instance, index }) => {
    const { 
        route_code, 
        instance_id, 
        is_complete, 
        total_cost, 
        flights = [] 
    } = instance;

    // 航段表格列定义
    const columns = [
        {
            title: '航段序号',
            dataIndex: 'leg_sequence',
            key: 'leg_sequence',
            width: 80,
            align: 'center',
            render: (seq) => <Tag color="blue">Leg {seq}</Tag>
        },
        {
            title: '航班号',
            dataIndex: 'flight_number',
            key: 'flight_number',
            width: 120,
        },
        {
            title: '航段',
            key: 'route_segment',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Text strong>{record.departure_airport}</Text>
                    <EnvironmentOutlined style={{ color: '#1890ff' }} />
                    <Text strong>{record.arrival_airport}</Text>
                </Space>
            )
        },
        {
            title: '起飞时间 (ATD)',
            dataIndex: 'atd',
            key: 'atd',
            width: 180,
            render: (time) => {
                if (!time) return '-';
                const date = new Date(time);
                return (
                    <Space>
                        <ClockCircleOutlined />
                        <span>{date.toLocaleString('zh-CN', { 
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}</span>
                    </Space>
                );
            }
        },
        {
            title: '到达时间 (ATA)',
            dataIndex: 'ata',
            key: 'ata',
            width: 180,
            render: (time) => {
                if (!time) return '-';
                const date = new Date(time);
                return (
                    <Space>
                        <ClockCircleOutlined />
                        <span>{date.toLocaleString('zh-CN', { 
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}</span>
                    </Space>
                );
            }
        },
        {
            title: 'BH (小时)',
            dataIndex: 'total_bh',
            key: 'total_bh',
            width: 100,
            align: 'right',
            render: (value) => {
                const bh = Number(value || 0);
                return (
                    <Text style={{ color: bh > 0 ? '#1890ff' : '#d9d9d9' }}>
                        {bh.toFixed(2)}
                    </Text>
                );
            }
        },
        {
            title: '成本 (USD)',
            dataIndex: 'total_cost',
            key: 'total_cost',
            width: 130,
            align: 'right',
            render: (cost) => (
                <Text strong>
                    ${Number(cost).toLocaleString('en-US', { 
                        minimumFractionDigits: 2, 
                        maximumFractionDigits: 2 
                    })}
                </Text>
            )
        }
    ];

    // Panel 标题
    const panelHeader = (
        <Space size="large">
            {/* 完整性标识 */}
            {is_complete ? (
                <Tag icon={<CheckCircleOutlined />} color="success">
                    完整
                </Tag>
            ) : (
                <Tag icon={<WarningOutlined />} color="warning">
                    不完整
                </Tag>
            )}
            
            {/* 航线代码 */}
            <Text strong style={{ fontSize: 16 }}>
                {route_code}
            </Text>

            {/* 飞机注册号 */}
            {flights.length > 0 && flights[0].aircraft_reg && (
                <Tag color="geekblue">
                    {flights[0].aircraft_reg}
                </Tag>
            )}
            
            {/* 实例编号 */}
            <Text type="secondary">
                实例 #{index + 1}
            </Text>
            
            {/* 航段数量 */}
            <Tag color="blue">
                {flights.length} 个航段
            </Tag>
            
            {/* 总成本 */}
            <Text strong style={{ color: '#52c41a' }}>
                总成本: ${Number(total_cost).toLocaleString('en-US', { 
                    minimumFractionDigits: 2, 
                    maximumFractionDigits: 2 
                })}
            </Text>
        </Space>
    );

    return (
        <Collapse
            defaultActiveKey={index === 0 ? ['1'] : []}
            style={{ marginBottom: 16 }}
        >
            <Panel header={panelHeader} key="1">
                {/* 航段列表 */}
                <Table
                    columns={columns}
                    dataSource={flights}
                    rowKey="flight_id"
                    pagination={false}
                    size="small"
                    bordered
                />
                
                {/* 实例ID（开发者信息） */}
                <div style={{ marginTop: 8, color: '#8c8c8c', fontSize: 12 }}>
                    实例ID: {instance_id}
                </div>
            </Panel>
        </Collapse>
    );
};

export default RouteInstanceCard;

